module.exports = __webpack_public_path__ + "static/media/libro5.9cc64867.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro5.png
// module id = 353
// module chunks = 0